import { put } from "@redux-saga/core/effects";
import axios from "axios";

import { UpdatePageRequestActionType } from "./../types";
import { IErrorType } from "./../../types/errors.d";
import { updatePageFailure, updatePageSuccess } from "./../actionCreators";
import { PagesService } from "./../../../services/pages";

import { undo } from "./../../../helpers/undoable";

export function* UpdatePageSaga(action: UpdatePageRequestActionType) {
    const { payload } = action;

    try {
        yield PagesService.updatePage(payload);

        yield put(updatePageSuccess({}));
    } catch (error) {
        yield put(undo(action));
        if (axios.isAxiosError(error))
            yield put(updatePageFailure({ id: payload._id, errorType: IErrorType.AXIOS, data: error.response?.data }));
        else yield put(updatePageFailure({ id: payload._id, errorType: IErrorType.NATIVE, data: error }));
    }
}
